import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPrices } from '../../../Onboarding/Pages/Publication/publicationSlice';
import httpErrorHandling from '../../../../utils/httpErrorHandling';
import SubscriptionType from '../../../../common/interfaces/Chargebee/SubscriptionType';
import { createAppAsyncThunk } from '../../../../common/thunk';
import PaymentService, { PaymentUpdateSubscriptionAttr } from '../../../../services/payment.service';
import ItemPriceType from '../../../../common/interfaces/Chargebee/ItemPriceType';
import ErrorType from '../../../../common/interfaces/Chargebee/ErrorType';

export const getSubscriptions = createAppAsyncThunk('subscriptions/get', () => {
  return PaymentService.getSubscriptions();
});

export const cancelSubscription = createAppAsyncThunk('subscriptions/cancelSubscription', (data: PaymentUpdateSubscriptionAttr) => {
  return PaymentService.cancelSubscription(data);
});

export const subscribe = createAppAsyncThunk('subscriptions/subscribe', (data: PaymentUpdateSubscriptionAttr) => {
  return PaymentService.subscribe(data);
});

interface ChangePasswordState {
  subscriptions: SubscriptionType[];
  prices: ItemPriceType[];
  error: string;
}

const initialState: ChangePasswordState = {
  subscriptions: [],
  prices: [],
  error: '',
};
export const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPrices.fulfilled, (state, action: PayloadAction<ItemPriceType[]>) => {
      state.prices = action.payload;
    });
    builder.addCase(getPrices.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(getPrices.pending, state => {
      state.error = '';
    });
    builder.addCase(getSubscriptions.fulfilled, (state, action: PayloadAction<SubscriptionType[]>) => {
      state.subscriptions = action.payload;
    });
    builder.addCase(getSubscriptions.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(getSubscriptions.pending, state => {
      state.error = '';
    });
    builder.addCase(subscribe.fulfilled, (state, action) => {
      state.subscriptions = [action.payload];
    });
    builder.addCase(subscribe.pending, state => {
      state.error = '';
    });
    builder.addCase(subscribe.rejected, (state, action) => {
      const payload = action.payload as ErrorType;
      state.error = payload.message;
    });
    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      state.subscriptions = [action.payload];
    });
    builder.addCase(cancelSubscription.pending, state => {
      state.error = '';
    });
    builder.addCase(cancelSubscription.rejected, (state, action) => {
      const payload = action.payload as ErrorType;
      state.error = payload.message;
    });
  },
});

export default subscriptionsSlice.reducer;
